export enum Gender { //Gender.cs
    Male = 1,
    Female = 2
}